<template>
    <v-container>
        <v-layout row style="margin-top: 80px;">
            <v-flex xs12 sm6 offset-sm3>
                <v-layout row v-if="error">
                    <v-flex xs12 sm12>
                        <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
                    </v-flex>
                </v-layout>
                <v-card>
                    <v-card-text>
                        <v-container grid-list-xl text-xs-center>
                            <form @submit.prevent="onSignUp">
                                <v-layout row>
                                     <v-flex xs12>
                                        <v-text-field name="firstName" label="First Name" id="firstName" v-model="firstName" type="text" required>
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                     <v-flex xs12>
                                        <v-text-field name="lastName" label="Last Name" id="lastName" v-model="lastName" type="text" required>
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs12>
                                        <v-text-field name="email" label="E-mail" id="email" v-model="email" type="email" required>
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs12>
                                        <v-btn 
                                        color="primary"
                                        style="width: 100%"
                                        type="submit" :disabled="loading" :loading="loading">Request account
                                            <span slot="loader" class="custom-loader">
                                                <v-icon light>cached</v-icon>
                                            </span>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </form>
                        </v-container>
                    </v-card-text>
                </v-card>
    
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        data() {
            return {
                email: '',
                firstName: '',
                lastName: ''
                
            }
        },
        computed: {
            // comparePasswords() {
            //     return this.password !== this.confirmPassword ? 'Password do not match' : ''
            // },
            user() {
                return this.$store.getters.user
            },
            error() {
                return this.$store.getters.error
            },
            loading() {
                return this.$store.getters.loading
            }
        },
        watch: {
            user(value) {
                if (value !== null && value !== 'undefined') {
                    this.$router.push('/')
                }
            }
        },
        methods: {
            onSignUp() {
                //vuex
                this.$store.dispatch('signUserUp', {email: this.email,
                                                    firstName: this.firstName,
                                                    lastName: this.lastName})
            },
            onDismissed() {
                this.$store.dispatch('clearError')
            }
        },
        props: {
            source: String
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Users/SignUp.vue